module.exports = __webpack_public_path__ + "u19.no2.8ec8bf6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u19.no2.jpg
// module id = PaNl
// module chunks = 0